export default __webpack_public_path__ + "static/hero-f9168fbf86c13084fac77f04894f270b.svg";